module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }

    module.initSearchBar = function () {

        $('.search-open').click(function () {
            $('#search').removeClass('d-none');
        });

        $('.search-close').click(function () {
            $('#search').addClass('d-none');

            module.initWowJs();
        });
    }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function () {

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };

    module.initStickyEl = function () {
        // Select the sticky nav element and its offset
        let el = $('.is-sticky');
        let stickyOffset = el.offset().top; // Get initial offset of the sticky element

        // Use requestAnimationFrame for smoother scroll handling
        let isScrolling = false;

        window.addEventListener('scroll', function () {
            if (!isScrolling) {
                window.requestAnimationFrame(function () {
                    module.addStickyClass(stickyOffset); // Pass the sticky element's original offset
                    isScrolling = false;
                });
            }
            isScrolling = true;
        });

        module.addStickyClass(stickyOffset); // Trigger on page load
    };

    module.addStickyClass = function (stickyOffset) {
        let body = $('body');
        let yOffset = window.pageYOffset; // Get current scroll position

        // Check if user has scrolled past the original position of the nav
        if (yOffset >= stickyOffset) {
            body.addClass("stuck").removeClass("before-stuck");
        } else {
            body.removeClass("stuck").addClass("before-stuck");
        }
    };


    // module.navDropdownHover = function () {
    //
    //     const $dropdown = $(".dropdown");
    //     const $dropdownToggle = $(".dropdown-toggle");
    //     const $dropdownMenu = $(".dropdown-menu");
    //     const showClass = "show";
    //
    //     $(window).on("load resize", function() {
    //         if (this.matchMedia("(min-width: 768px)").matches) {
    //             $dropdown.hover(
    //                 function() {
    //                     const $this = $(this);
    //                     $this.addClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "true");
    //                     $this.find($dropdownMenu).addClass(showClass);
    //                 },
    //                 function() {
    //                     const $this = $(this);
    //                     $this.removeClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "false");
    //                     $this.find($dropdownMenu).removeClass(showClass);
    //                 }
    //             );
    //         } else {
    //             $dropdown.off("mouseenter mouseleave");
    //         }
    //     });
    // };


    module.announcementBarDismiss = function () {
        if ($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.initSpotlightJs = function () {
        if ($('.spotlight').length)
            require('spotlight.js');
    };


    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });
    };

    module.initLightbox = function () {
        require('ekko-lightbox');
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                leftArrow: '<i class="fa fa-chevron-left left"></i>',
                rightArrow: '<i class="fa fa-chevron-right right"></i>'
            });
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        $('.slick.testimonials-slides').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            arrows: false,
            cssEase: 'linear',
            dots: false,
            centerMode: true,
            centerModePadding: '250px',

            responsive: [

                {
                    breakpoint: 992, // sm
                    settings: {
                        slidesToShow: 1
                    }
                },

            ]


        });

        $('.slick.shortcode-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: false,
            dots: true,
            cssEase: 'linear',
        });

        $('.slick.slides').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            dots: false,
            appendArrows: $('.arrows-container .arrows')
        });

        $('.slick.product-images').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            dots: false,
        });

        $('.vertical').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            dots: false,
            vertical: true,
            prevArrow: $('.product-prev'),
            nextArrow: $('.product-next'),

            responsive: [

                {
                    breakpoint: 768,
                    settings: {
                        vertical: false,
                    }
                },
            ]

        });

        $('.slick.carousel').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable: false,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });

        $('.slick.product-carousel').slick({
            infinite: false,
//            asNavFor: '.slider-for',
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            //  dots:true,
            //  appendDots: $('.product-dots-container'),
            appendArrows: $('.product-arrows-container .arrows')
        });

    };


    module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };
    module.bornHS = function () {

        $('.BornHS__Input').change(function () {
            if ($(this).is(":checked")) {
                $('.BornHS__Wrapper').addClass("BornHS__Blur");

                // Use a one-time event listener for the document click
                $(document).one('click.bornHS', function (e) {

                    // Check if the clicked target is not inside the .BornHS__Input
                    if (!$(e.target).closest('.BornHS__Input').length) {
                        // Remove the class and uncheck the input
                        $('.BornHS__Wrapper').removeClass("BornHS__Blur");
                        $('.BornHS__Input').prop('checked', false);
                    }
                });

            } else {
                $('.BornHS__Wrapper').removeClass("BornHS__Blur");
            }
        });

    };

    module.cartInit = function () {

        $('.btn-number').click(function (e) {
            e.preventDefault();

            fieldName = $(this).attr('data-field');
            type = $(this).attr('data-type');
            var input = $("input[name='" + fieldName + "']");
            var currentVal = parseInt(input.val());
            if (!isNaN(currentVal)) {
                if (type == 'minus') {

                    if (currentVal > input.attr('min')) {
                        input.val(currentVal - 1).change();
                    }
                    if (parseInt(input.val()) == input.attr('min')) {
                        $(this).attr('disabled', true);
                    }

                } else if (type == 'plus') {

                    if (currentVal < input.attr('max')) {
                        input.val(currentVal + 1).change();
                    }
                    if (parseInt(input.val()) == input.attr('max')) {
                        $(this).attr('disabled', true);
                    }

                }
            } else {
                input.val(0);
            }
        });
        $('.input-number').focusin(function () {
            $(this).data('oldValue', $(this).val());
        });
        $('.input-number').change(function () {

            minValue = parseInt($(this).attr('min'));
            maxValue = parseInt($(this).attr('max'));
            valueCurrent = parseInt($(this).val());

            name = $(this).attr('name');
            if (valueCurrent >= minValue) {
                $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
            } else {
                alert('Sorry, the minimum value was reached');
                $(this).val($(this).data('oldValue'));
            }
            if (valueCurrent <= maxValue) {
                $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
            } else {
                alert('Sorry, the maximum value was reached');
                $(this).val($(this).data('oldValue'));
            }
        });

        $(".input-number").keydown(function (e) {
            // Allow: backspace, delete, tab, escape, enter and .
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode == 65 && e.ctrlKey === true) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });


        $('.cart-container .quantity').on('change', function () {

            let item = $(this).parents('.item');

            $.ajax({
                type: "POST",
                url: '/cart/update',
                data: {
                    'id': item.data('id'),
                    'quantity': item.find('.quantity').val(),
                },
                headers: {
                    'x-csrf-token': $('meta[name=csrf-token]').attr('content'),
                },
                success: function (data) {
                    if (data.success) {


                    }
                }
            });
        });


        $('.cart-add').click(function () {

            $.ajax({
                type: "POST",
                url: '/cart/add',
                data: {
                    'id': $(this).data('id'),
                    'quantity': $(this).parents('.item').find('.quantity').val(),
                },
                headers: {
                    'x-csrf-token': $('meta[name=csrf-token]').attr('content'),
                },
                success: function (data) {
                    if (data.success) {

                        let SweetAlert = require('sweetalert2');

                        SweetAlert.fire({
                            title: 'Added to order!',
                            text: 'We\'ve added this to your order list',
                            icon: 'success',
                            showCancelButton: true,
                            confirmButtonText: 'View order list',
                            cancelButtonText: 'Keep browsing'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location = "/cart";
                            }
                        })
                    }
                }
            });
        });

        $('.cart-remove').click(function () {
            let id = $(this).data("id");

            $.ajax({
                type: "POST",
                url: '/cart/remove',
                data: {'id': $(this).data('id')},
                headers: {
                    'x-csrf-token': $('meta[name=csrf-token]').attr('content'),
                },
                success: function (data) {
                    if (data.success) {

                        $('.cart-container .item[data-id="' + id + '"').addClass('removed');
                        let SweetAlert2 = require('sweetalert2');

                        SweetAlert2.fire({
                            title: 'Removed from order!',
                            text: 'We\'ve removed this item from your order list',
                            icon: 'success',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'Continue'
                        });

                    }
                }
            });
        });
    }


    module.setProductEnlargeImage = function () {
        const slickElement = document.querySelector('.slick.product-images');
        const enlargeButton = document.getElementById('enlarge-btn');

        if (slickElement && enlargeButton) {
            $(slickElement).on('afterChange', function (event, slick, currentSlide) {
                // Find the currently active slide's link
                const currentAnchor = slick.$slides.eq(currentSlide).find('a');
                const newHref = currentAnchor.attr('href');

                // Update the enlarge button's href
                if (newHref) {
                    enlargeButton.setAttribute('href', newHref);
                }
            });

            // Set initial href (first slide)
            const firstSlideAnchor = $(slickElement).find('.slick-slide:first a');
            if (firstSlideAnchor.length) {
                enlargeButton.setAttribute('href', firstSlideAnchor.attr('href'));
            }
        }
    };


    return module;

};

